import React, { lazy, Suspense } from 'react'
import CloudAccountWrapper from './CloudAccountWrapper/CloudAccountWrapper'
import { CloudOption } from '@labrav/react-components'
import { useTenantPartnerId, SnackBar, type CloudType } from '@labrav/common'
import { useFlagValue } from '@labrav/flags'
import { FlyoutBlockPage } from '../../common/components/FlyoutBlockPage'
import { useDispatch } from '../../store'
import { createAccountAction } from './accountSelectionActions'
import { useParams } from 'react-router-dom'
import { customerFormData, isProductActive } from './useFlyoutSettingsAccess'
import { flyoutCloudAccountOptions } from './constants'

const FlyoutCloudAccountContent = lazy(() => import('./CloudAccountContent'))

interface FlyoutCloudAccountProps {
  isExternal?: boolean
}

const FlyoutCloudAccountWrapper: React.FC<FlyoutCloudAccountProps> = ({
  isExternal = false,
}) => {
  const isFlyOutInActiveProducts = isProductActive('flyout') || isExternal
  const partnerInviteEnabled = useFlagValue('partnerInvite')
  const dispatch = useDispatch()
  const tenantPartnerId =
    useTenantPartnerId() || useParams<{ partnerId: string }>()?.partnerId
  const customerData = customerFormData()
  const flyoutProduct = customerData.subscribedProducts.FLYOUT
  const isFlyoutSubscribed =
    !partnerInviteEnabled?.value ||
    ((flyoutProduct?.cloudProviders || []).length ?? 0 > 0) ||
    isExternal
  const handleCloudSelect = (option: CloudOption) => {
    if (tenantPartnerId) {
      dispatch(
        createAccountAction(tenantPartnerId, {
          cloud: option.name as CloudType,
          product: 'flyout',
          name: 'Setup your Account',
          partnerId: tenantPartnerId,
        })
      )
    }
  }
  return (
    <>
      <Suspense fallback={<div />}>
        {isFlyOutInActiveProducts && isFlyoutSubscribed ? (
          <CloudAccountWrapper
            title="Cloud accounts"
            onCloudSelect={handleCloudSelect}
            cloudOptions={flyoutCloudAccountOptions}
            ContentComponent={FlyoutCloudAccountContent}
          />
        ) : (
          <FlyoutBlockPage showHeader={false} />
        )}
      </Suspense>
      <SnackBar />
    </>
  )
}

export default FlyoutCloudAccountWrapper
export { FlyoutCloudAccountWrapper }
